module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 147.db4aade7.png";